/**
 * Periop list rows from Springhouse add-on surgery use appointment_id "0" (no OPM row).
 * Treat them as SURGERY for Med Management vs Joint Decisions filtering.
 */
export const SYNTHETIC_PERIOP_APPOINTMENT_ID = '0';

export function effectiveAppointmentType(patient) {
  if (!patient) return undefined;
  if (patient.appointment_id != null && String(patient.appointment_id) === SYNTHETIC_PERIOP_APPOINTMENT_ID) {
    return 'SURGERY';
  }
  return patient.appointment_type;
}

/** Unique list/calendar row when the same patient has both an MM and a JD appointment. */
export function listRowKey(patient) {
  if (!patient?.id) return '';
  return `${patient.id}::${patient.appointment_id ?? ''}`;
}
